import React from "react";

const BlueGem = ({ className }) => {
  return (
    <svg
      id="Capa_1"
      enable-background="new 0 0 511.98 511.98"
      viewBox="0 0 511.98 511.98"
      className={className}
    >
      <g>
        <g>
          <path
            d="m350.615 58.682h-189.25c-1.857 0-3.688.341-5.415.986l-10 52.19 10 52.19 100.163 10 99.915-10 10-52.683-10-51.697c-1.725-.644-3.557-.986-5.413-.986z"
            fill="#cef7ff"
          />
          <path
            d="m356.029 59.668c-1.726-.644-3.558-.986-5.415-.986h-94.624v115.353l.124.012 99.915-10 10-52.683z"
            fill="#85eafd"
          />
        </g>
        <g>
          <path
            d="m155.951 164.048 18.999 101.6 58.422 169.65 10.885 12.623c6.181 7.168 17.288 7.168 23.468 0l10.885-12.623 58.422-169.65 18.999-101.6z"
            fill="#85eafd"
          />
          <path
            d="m255.99 164.048v289.25c4.322 0 8.644-1.792 11.734-5.376l10.885-12.623 58.422-169.65 18.999-101.6h-100.04z"
            fill="#54c4fc"
          />
        </g>
        <path
          d="m153.586 60.777-145.885 84.697c-6.667 3.871-9.217 11.794-6.814 18.574h155.064v-104.38c-.814.304-1.608.669-2.365 1.109z"
          fill="#85eafd"
        />
        <path
          d="m504.28 145.474-145.886-84.697c-.757-.44-1.551-.805-2.365-1.109v104.379h155.064c2.404-6.779-.146-14.703-6.813-18.573z"
          fill="#54c4fc"
        />
        <path
          d="m.887 164.048c.622 1.753 1.557 3.434 2.859 4.944l229.626 266.307-77.42-271.251z"
          fill="#54c4fc"
        />
        <path
          d="m356.029 164.048-77.42 271.251 229.625-266.307c1.302-1.51 2.237-3.191 2.859-4.944z"
          fill="#7788fa"
        />
      </g>
    </svg>
  );
};

export default BlueGem;
